<template>
  <el-dialog
    :title="titleDialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onHandleClose"
    width="30%"
    class="dialog"
    center
  >
    <div class="contents">
      <div class="child">{{ `选中数量：${selectIds.length}条` }}</div>
      <div class="child">{{ `每条扣款金额：${selectIds[0].deduction_amt}元` }}</div>
      <div class="child">{{ `责任方：${selectIds[0].head_type_text}` }}</div>
      <div class="child" style="display: flex;align-items: center;">{{ `修改金额：` }}<el-input v-model="formData.deduction_amt" style="width: 60%;" placeholder="请输入金额"></el-input></div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取消</el-button>
      <el-button type="primary" @click="onHandleSubmit" :loading="loadingSubmit"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>

import { deductionbatchupdateV2 } from "@/api/general/operation-center/index";
export default {
  name: "DeductDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      loadingSubmit: false,
      titleDialog: "是否确认批量修改？",
      formData: {
        deduction_amt: 0, // 累计扣款
        aftersale_detail_ids: [], // 城市仓扣款
       
      }, // 表单数据
      selectIds: [], // 当前选中的数据ID
    };
  },
  methods: {
    /**
     * 初始化
     */
    async onInitData(data) {
      this.selectIds=data;
      this.formData.deduction_amt=this.selectIds[0].deduction_amt;
      this.formData.aftersale_detail_ids=data.map(el=>el.id);
      this.dialogVisible = true;

    },
    /**
     * 关闭操作
     */
    onHandleClose() {
    
      this.dialogVisible = false;
    },

    /**
     * 确认
     */
    onHandleSubmit() {
      this.ajaxPostQcRefundDeductionDone();
    },
    /**
     * 提交
     */
    async ajaxPostQcRefundDeductionDone() {
      this.loadingSubmit = true;
      try {
      
        await deductionbatchupdateV2(this.formData);
        this.$message.success("操作成功");
        this.$emit("on-change");
        this.onHandleClose();
      } catch (err) {
        console.log("ajax deductionbatchupdateV2 err", err);
      } finally {
        this.loadingSubmit = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .contents {
    padding-top: 30px;
    padding-bottom: 20px;
    padding-left: 150px;
    .child {
      line-height: 40px;
      font-size: 16px;
      font-weight: 550;
    }
  }
  /deep/ .el-form {
    margin-left: 120px;
  }
  .el-input,
  .el-select {
    width: 400px;
  }
}
</style>
